import { Fragment, ReactElement } from 'react'
import styled from 'styled-components'

import { SectionDiv, SummaryDiv } from '../TextStyle'
import { usingTerms, usingTermsLinks } from './UsingIterms'
import { LinkText } from '@/components/elements/LinkText'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'
import { Index } from '@/components/layouts/Legal/Index'

const sectionTitle = {
  titleText: 'Terms of Use',
  subTitleText: '利用条件',
}

const tSummary = (
  <>
    <p>
      トライアルグループ（株式会社トライアルホールディングス及びそのグループ会社※をいいます。）が運営するウェブサイト（以下、「本ウェブサイト」といいます。）においては、本ウェブサイトを利用することをもって、本ウェブサイトをご利用される方（以下、「利用者」といいます。）は、ご利用条件（以下、「本利用条件」といいます。）に同意したものとみなされます。
      <br />
      なお、本利用条件は変更される場合があります。利用者におかれましては、最新の内容をご確認いただきますようお願いいたします。
    </p>
    <p>
      ※株式会社トライアルホールディングスのグループ会社は
      <LinkText path="/company/overview/" text="こちら" />
      です。
    </p>
  </>
)

export const UsingTermsPage = () => {
  return (
    <>
      <Head
        title="利用規約"
        description="トライアルホールディングスの利用規約を掲載しています。"
        ogp={{ type: 'article', url: 'legal/terms/' }}
      />
      <UsingContainer>
        <CompleteTitle>
          <SectionTitle
            color="normal"
            titleText={sectionTitle.titleText}
            subTitleText={sectionTitle.subTitleText}
          />
        </CompleteTitle>
        <Spacer h={{ pc: 70, sp: 60 }} />
        <SummaryDiv>{tSummary}</SummaryDiv>
        <Spacer h={{ pc: 70, sp: 35 }} />
        <Index columnGap={84} listType="article" links={usingTermsLinks} />
        <Spacer h={{ pc: 70, sp: 40 }} />
        {usingTerms.map(({ children, id }, index) => (
          <Fragment key={`${id}${index}`}>
            <SectionDiv id={id}>{children}</SectionDiv>
            {index < usingTerms.length - 1 && <Spacer h={{ pc: 70, sp: 39 }} />}
          </Fragment>
        ))}
      </UsingContainer>
    </>
  )
}
UsingTermsPage.getLayout = (page: ReactElement) => {
  const pageTitle = {
    title: 'Legal',
    subTitle: '法務',
  }

  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '法務', path: '/legal/' },
    { name: '利用条件', path: '' },
  ]

  return (
    <TitleLayout
      {...pageTitle}
      breadCrumbs={breadCrumbs}
      isRequiredBackground={false}
    >
      {page}
    </TitleLayout>
  )
}

const UsingContainer = styled.div`
  width: 1040px;
  padding-top: 62px;
  padding-bottom: 130px;
  margin: 0 auto;

  @media screen and (max-width: 1047px) {
    width: 100%;
    padding: 40px 20px 70px;
  }
`

const CompleteTitle = styled.div`
  width: 100%;
  margin: 0 auto;
  @media screen and (max-width: 1047px) {
    max-width: 200px;
  }
`
